export default {
  downloadPlural: 'Download source files',
  plural: 'Source files',
  uploadPlural: 'Upload source files',
  uploadSource: 'Upload source'
};
